import PropTypes from "prop-types";
import * as React from "react";
import QuickActionTile from "../templates/quickActionTile";
import SingleLinkTile from "../templates/singleLinkTile";
import { FIELDGLASS } from "../../../constants/externalUrls";
import { quickActionTilesMap } from "../tilesMap";

const FieldglassNonSSOTile = ({ id }) => {
    return (
        <QuickActionTile id={id}>
            <SingleLinkTile
                link={FIELDGLASS}
                linkText={quickActionTilesMap[id].description}
                title={"Fieldglass"}
            />
        </QuickActionTile>
    );
};

FieldglassNonSSOTile.propTypes = {
    id: PropTypes.string.isRequired,
};

export default FieldglassNonSSOTile;
